import { render, staticRenderFns } from "./SportAnalyze.vue?vue&type=template&id=fac18e74&scoped=true&"
import script from "./SportAnalyze.vue?vue&type=script&lang=js&"
export * from "./SportAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./SportAnalyze.vue?vue&type=style&index=0&id=fac18e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac18e74",
  null
  
)

export default component.exports